PJQ.maps = {};

PJQ.maps.GoogleMap = class {
	constructor($el, options = {}) {
		this.options = _.defaults(options, {
			mapId: 'map_' + _.uniqueId(),
			zoom: 4,
			center: new google.maps.LatLng(38.6159, -100.7456),
			mapTypeId: google.maps.MapTypeId.ROADMAP
		});
		this.$el = $el;
		this.$el.attr('id', this.options.mapId);
		this.initMap();
	}

	initMap() {
		this.mapObjects = {};
		this.map = new google.maps.Map(this.$el[0], {
			zoom: this.options.zoom,
			center: this.options.center,
			mapTypeId: this.options.mapTypeId,
			gestureHandling: 'cooperative'
		});
	}

	addMarker(latitude, longitude, options = {}) {
		let id = _.uniqueId(),
			marker = new google.maps.Marker({
				position: new google.maps.LatLng(latitude, longitude),
				map: this.map,
				title: options.title,
				animation: google.maps.Animation.DROP
			});
		this.mapObjects[id] = marker;
		if (_.size(options.infoWindowContent) > 0) {
			let infoWindow = new google.maps.InfoWindow({
				content: options.infoWindowContent
			});
			marker.addListener('click', function () {
				infoWindow.open(this.map, marker);
			});
		}
	}

	addKMLStatesLayer(states) {
		let id = _.uniqueId(),
			src = PJQ.helpers.urlHelpers.buildAPIURL('/workareas/kml?states=' + states.join(','), false, false, true);
		this.mapObjects[id] = new google.maps.KmlLayer(src, {
			suppressInfoWindows: true,
			preserveViewport: true,
			map: this.map
		});
		return id;
	}

	addKMLCountiesLayer(countyIds) {
		let id = _.uniqueId(),
			countyEncode = PJQ.compression.encode.runLength(PJQ.compression.encode.delta(countyIds)),
			src = PJQ.helpers.urlHelpers.buildAPIURL('/workareas/kml?countyIds=' + countyEncode.join(','), false, false, true);
		this.mapObjects[id] = new google.maps.KmlLayer(src, {
			suppressInfoWindows: true,
			preserveViewport: true,
			map: this.map
		});
		return id;
	}

	removeMapObject(id) {
		let object = this.mapObjects[id];
		if (object != null) {
			object.setMap(null);
		}
	}

	resize() {
		google.maps.event.trigger(this.map, 'resize');
	}

	setCenter(center) {
		this.map.setCenter(center);
	}

	setZoom(zoom) {
		this.map.setZoom(zoom);
	}
};

PJQ.views.SuperMap = PJQ.views.BaseView.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Super-Map'),
		mapZoom: 4,
		isDetail: false,
		isActive: true
	},
	events: {
		'click .btn-edit-super': 'editSuper',
		'click .btn-go-to-super': 'goToSuper',
		'click .user-edit-text-map': 'infoWindowEditSuper',
		'keyup .datatable-search': 'search',
		'click .clear-filters': 'clearFilters'
	},
	beforeFirstRender() {
		if (this.collection == null) {
			this.collection = new PJQ.collections.users.Users(null, {
				isDetail: this.options.isDetail
			});
		}

		this.customFields = null;
		if (!this.options.isFetched) {
			this.collection.fetch({
				success: _.bind(function () {
					PJQ.app.session.fetchUserCustomFields(PJQ.app.session.user.get('masterUserId'), _.bind(function(customFields) {
						this.customFields = customFields;
						this.options.isFetched = true;
						this.render();

						if (typeof this.options.onFetch === 'function') {
							this.options.onFetch();
						}
					}, this));
				}, this)
			});
		}
		else {
			this.render();
		}
	},
	beforeRender: function () {
		this.renderData = {
			isDetail: this.options.isDetail,
			options: this.options,
			collection: this.collection
		};
		this.filtered = [];
		_.each(this.collection.models, function (model) {
			if (model.attributes.userTypeId === 396 || model.attributes.userTypeId === 3738) {
				if (!this.options.isActive || model.attributes.isActive)
					this.filtered.push(model)
			}
		}, this);
	},
	afterRender: function () {
		let columns = [];

		if (this.options.isDetail) {
			this.statusSelectPicker = new PJQ.inputs.Selectpicker({
				el: this.$('select.status-filter'),
				defaultValue: [10,12,16,15,13,14,11,17,18],
				isMultiple: true,
				isIntChoices: true,
				onChange: _.bind(function () {
					this.statusFilterChanged();
				}, this)
			});

			columns = [
				{
					"data": "attributes.contactName",
					"title": "Name"
				},
				{
					"data": "attributes.phone",
					"title": "Phone",
					"render": function (data) {
						return PJQ.helpers.formatHelpers.formatPhoneNumber(data);
					}
				},
				{
					"data": "attributes.cell",
					"title": "Cell",
					"render": function (data) {
						return PJQ.helpers.formatHelpers.formatPhoneNumber(data);
					}
				},
				{
					"data": "attributes.email",
					"title": "Email",
					"render": function (data) {
						return '<a href="mailto:' + data + '">' + data + '</a>';
					}
				},
				{
					"data": "attributes",
					"title": "Address",
					"render": function (data, type, row) {
						let addr = row.get('address1');
						if (_.size(row.get('address2')) > 0) {
							addr += (' ' + row.get('address2'));
						}
						return addr;
					}
				},
				{
					"data": "attributes.city",
					"title": "City"
				},
				{
					"data": "attributes.state",
					"title": "State"
				},
				{
					"data": "attributes.zip",
					"title": "Zip",
					"render": _.bind(function (data) {
						if (data.length < 5) {
							return ""
						}
						else {
							return data
						}
					})
				},
				{
					"data": "attributes.fieldValue1",
					"title": "Last Safety",
					"render": _.bind(function (data, type, row) {
						let value = this.getUserCustomFieldValue(row, 1);
						return value ? PJQ.helpers.dateHelpers.getDateString(new Date(value), PJQ.helpers.dateHelpers.dateFormats.DATE, true) : '';
					}, this)
				},
				{
					"data": "attributes.fieldValue2",
					"title": "Last Proc.",
					"render": _.bind(function (data, type, row) {
						let value = this.getUserCustomFieldValue(row, 2);
						return value ? PJQ.helpers.dateHelpers.getDateString(new Date(value), PJQ.helpers.dateHelpers.dateFormats.DATE, true) : '';
					}, this)
				},
				{
					"data": "attributes.fieldValue6",
					"title": "OSHA",
					"render": _.bind(function (data, type, row) {
						let value = this.getUserCustomFieldValue(row, 6);
						return this.getUserCustomFieldChoice(value, 6);

					}, this)
				},
				{
					"data": "attributes.fieldValue12",
					"title": "Status",
					"render": _.bind(function (data, type, row) {
						let value = this.getUserCustomFieldValue(row, 12);
						return this.getUserCustomFieldChoice(value, 12);
					}, this)
				},
				{
					"data": "attributes.fieldValue16",
					"title": "Pref. PM",
					"render": _.bind(function (data, type, row) {
						return this.getUserCustomFieldValue(row, 16);
					}, this)
				},
				{
					"data": "attributes.fieldValue17",
					"title": "Insurance",
					"render": _.bind(function (data, type, row) {
						let value = this.getUserCustomFieldValue(row, 17);
						return this.getUserCustomFieldChoice(value, 17);
					}, this)
				},
				{
					"data": "attributes.zip",
					"title": "",
					"orderable": false,
					"searchable": false,
					"width": "80px",
					"render": _.bind(function (data) {
						let editButtonHtml = PJQ.app.session.hasPermission('settings.canManageUsers') ? '<button type="button" class="btn btn-info btn-edit-super ht-30p wd-35p mr-1"><span class="fas fa-pencil"></span></button>' : '';
						if (data.length === 5) {
							return '<div class="text-align-right show-on-row-hover">'+editButtonHtml+'<button type="button" class="btn btn-orange btn-go-to-super ht-30p wd-35p"><span class="fas fa-map-marked-alt"></span></button></div>';
						}
						else {
							return _.size(editButtonHtml)>0 ? '<div class="text-align-right show-on-row-hover">'+editButtonHtml+'</div>' : '';
						}
					}, this)
				}
			];
		} else {
			columns = [
				{
					"data": "attributes.contactName",
					"title": "Name"
				},
				{
					"data": "attributes.phone",
					"title": "Phone",
					"render": function (data) {
						return PJQ.helpers.formatHelpers.formatPhoneNumber(data);
					}
				},
				{
					"data": "attributes.email",
					"title": "Email",
					"render": function (data) {
						return '<a href="mailto:' + data + '">' + data + '</a>';
					}
				},
				{
					"data": "attributes",
					"title": "Address",
					"render": function (data, type, row) {
						let addr = row.get('address1');
						if (_.size(row.get('address2')) > 0) {
							addr += (' ' + row.get('address2'));
						}
						return addr;
					}
				},
				{
					"data": "attributes.city",
					"title": "City"
				},
				{
					"data": "attributes.zip",
					"title": "Zip",
					"render": _.bind(function (data) {
						if (data.length < 5) {
							return ""
						}
						else {
							return data
						}
					})
				},
				{
					"data": "attributes.state",
					"title": "State"
				},
				{
					"data": "attributes.zip",
					"title": "",
					"orderable": false,
					"searchable": false,
					"width": "80px",
					"render": _.bind(function (data) {
						let editButtonHtml = PJQ.app.session.hasPermission('settings.canManageUsers') ? '<button type="button" class="btn btn-info btn-edit-super ht-30p wd-35p mr-1"><span class="fas fa-pencil"></span></button>' : '';
						if (data.length === 5) {
							return '<div class="text-align-right show-on-row-hover">'+editButtonHtml+'<button type="button" class="btn btn-orange btn-go-to-super ht-30p wd-35p"><span class="fas fa-map-marked-alt"></span></button></div>';
						}
						else {
							return _.size(editButtonHtml)>0 ? '<div class="text-align-right show-on-row-hover">'+editButtonHtml+'</div>' : '';
						}
					}, this)
				}
			];
		}

		this.superMapDataTable = new PJQ.views.dataTables.DataTable({
			el: this.$('.super-map-data-table'),
			data: this.filtered,
			language: {
				emptyTable: "No Superintendents exist",
				zeroRecords: "No Superintendents match this criteria"

			},
			paging: false,
			info: false,
			rowId: "cid",
			deferRender: true,
			columns: columns,
			isHideSearch: true,
			dom: "t"
		});
		if (this.collection.isFetched) {
			this.renderMap();
			this.renderCounts(this.filtered);
		}
	},
	clearFilters: function() {
		this.$('.datatable-search').val('');
		if (this.options.isDetail) {
			this.statusSelectPicker.setValue([10, 12, 16, 15, 13, 14, 11, 17, 18]);
			this.statusFilterChanged();
		}
		else {
			this.search();
		}
	},
	statusFilterChanged: function() {
		let values = this.statusSelectPicker.getValue();
		this.filtered = [];
		_.each(this.collection.models, function (model) {
			if (model.attributes.userTypeId === 396 || model.attributes.userTypeId === 3738) {
				if ((!this.options.isActive || model.attributes.isActive) && (values.indexOf(parseInt(this.getUserCustomFieldValue(model, 12))) !== -1 || (values.length === 9 && _.size(this.getUserCustomFieldValue(model, 12))===0)))
					this.filtered.push(model)
			}
		}, this);

		this.superMapDataTable.dataTable.clear();
		this.superMapDataTable.dataTable.rows.add(this.filtered);

		this.search();
	},
	search: function() {
		this.superMapDataTable.dataTable.search(this.$('.datatable-search').val()).draw();
	},
	getUserCustomFieldValue: function (row, id) {
		let match = _.find(row.get('userCustomFieldValues'), function (cf) {
			return (cf.fieldNumber === id);
		});
		return match ? match.value : null;
	},
	getUserCustomFieldChoice: function (value, id) {
		let match = _.find(this.customFields.models, function (cf) {
			return (cf.get('fieldNumber') === id);
		});
		let result = '';
		if (match) {
			_.each(match.choices.models, function(choice) {
				if (choice.id === value)
					result = choice.get('choiceName');
			});
		}

		return result;
	},
	renderCounts: function(models) {
		let retired = 0,
			active = 0,
			activeNew = 0,
			retiredToOffice = 0,
			activeSub = 0,
			neverUse = 0,
			retiredSub = 0,
			inactiveSub = 0,
			inactiveSuper = 0;

		_.each(models, function(model) {
			_.each(model.get('userCustomFieldValues'), function(customFieldValue) {
				if (customFieldValue.fieldNumber === 12) { // status
					switch(customFieldValue.value) {
						case 10:
							retired++;
							break;
						case 12:
							active++;
							break;
						case 16:
							activeNew++;
							break;
						case 15:
							retiredToOffice++;
							break;
						case 13:
							activeSub++;
							break;
						case 14:
							neverUse++;
							break;
						case 11:
							retiredSub++;
							break;
						case 17:
							inactiveSub++;
							break;
						case 18:
							inactiveSuper++;
							break;
					}
				}
			});
		});

		this.$('.total-retired').text(retired);
		this.$('.total-active').text(active);
		this.$('.total-active-new').text(activeNew);
		this.$('.total-retired-office').text(retiredToOffice);
		this.$('.total-active-sub').text(activeSub);
		this.$('.total-never-use').text(neverUse);
		this.$('.total-retired-sub').text(retiredSub);
		this.$('.total-inactive-sub').text(inactiveSub);
		this.$('.total-inactive-super').text(inactiveSuper);
	},
	renderMap: function () {
		this.map = new PJQ.maps.GoogleMap(this.$('.super-map'), {
			zoom: this.options.mapZoom
		});
		this.renderMarkers(this.filtered);
		this.watchSearch();
	},
	makeInfoWindow: function (user) {
		return "<div class=\"fs-18 user-edit-text-map text-primary font-weight-light mb-n3 mt-n1\" id='" + user.get('userId') + "'>" + user.get('contactName') + "</div><p><br />" +
			"<b>Phone:</b> " + PJQ.helpers.formatHelpers.formatPhoneNumber(user.get('phone')) + "<br />" +
			"<b>Email:</b> " + user.get('email') + "<br />" +
			"<b>Address:</b> " + user.get('address1') + "<br/>" +
			"<b>City:</b> " + user.get('city') + "<br />" +
			"<b>State:</b> " + user.get('state') + "<br />" +
			"<b>Zip:</b> " + user.get('zip') + "</p>";
	},
	renderMarkers: function (source) {
		_.each(source, function (user) {
			let latitude = user.get('latitude'),
				longitude = user.get('longitude');
			if (latitude !== 0 && longitude !== 0) {
				this.map.addMarker(latitude, longitude, {
					infoWindowContent: this.makeInfoWindow(user),
					title: user.get('contactName')
				});
			}
		}, this);
	},
	removeMarkers() {
		_.each(this.map.mapObjects, function (marker) {
			marker.setMap(null)
		});
	},
	infoWindowEditSuper: function (e) {
		if (!PJQ.app.session.hasPermission('settings.canManageUsers'))
			return;
		
		let target = $(e.currentTarget);
		let id = parseInt(target.context.id);
		_.each(this.filtered, function (user) {
			if (user.get('userId') === id) {
				new PJQ.views.contacts.BaseEditContactModal({
					model: user,
					onSave: _.bind(function () {
						this.superMapDataTable.refresh();
						this.removeMarkers();
						this.renderMarkers(this.filtered)
					}, this)
				});
			}
		}, this);
	},
	editSuper: function (e) {
		let target = $(e.currentTarget),
			row = this.superMapDataTable.getRow(target.closest('tr')),
			user = row.data();
		new PJQ.views.contacts.BaseEditContactModal({
			model: user,
			onSave: _.bind(function () {
				this.superMapDataTable.refresh();
				this.removeMarkers();
				this.renderMarkers(this.filtered)
			}, this)
		});
	},
	goToSuper: function (e) {
		let target = $(e.currentTarget),
			row = this.superMapDataTable.getRow(target.closest('tr')),
			user = row.data();
		this.map.setCenter({lat: user.get('latitude'), lng: user.get('longitude')});
		this.map.setZoom(8);
		_.each(this.map.mapObjects, function (marker) {
			if (user.get('longitude') === 0 || user.get('latitude') === 0) {
				return;
			}

			if (marker.getPosition().lng().toFixed(5) === user.get('longitude').toFixed(5) && marker.getPosition().lat().toFixed(5) === user.get('latitude').toFixed(5)) {
				if (this.infoWindow) {
					this.infoWindow.close();
				}
				this.infoWindow = new google.maps.InfoWindow({
					content: this.makeInfoWindow(user)
				});
				this.infoWindow.open(this.map, marker)
			}
		}, this)
	},
	watchSearch: function () {
		this.superMapDataTable.dataTable.on('search.dt', _.bind(function () {
			this.filterArray = [];

			let self = this;
			this.superMapDataTable.dataTable.rows({filter: 'applied'}).every(function () {
				self.filterArray.push(this.data());
			});

			this.removeMarkers();
			this.renderMarkers(this.filterArray);
			this.renderCounts(this.filterArray);
		}, this))
	},
});

PJQ.app.addRoutes([
	{
		route: 'supermap',
		name: 'supermap',
		callback: function () {
			new PJQ.views.SuperMap({
				el: $('#pjq-main')
			});
		}
	},
	{
		route: 'supermapall',
		name: 'supermapall',
		callback: function () {
			new PJQ.views.SuperMap({
				el: $('#pjq-main'),
				isDetail: true,
				isActive: false
			});
		}
	}
]);

